import { baseApi } from '@shared/config/environments/production'
import { composeQueryParams } from '@shared/lib'
import { Partners } from '@shared/lib/partner'

interface GetRedirectUrlArgs {
  id: string
  url?: string
  isWebView?: boolean
  isFromPubgGiveawayPage?: boolean
  partner?: Partners
  isNonTopUpService?: boolean
  isTopUpWithPercentFeeService?: boolean
}

export const getSbpRedirectUrl = ({
  id,
  url = '',
  isWebView = false,
  isFromPubgGiveawayPage = false,
  partner = Partners.DEFAULT,
  isNonTopUpService = false,
  isTopUpWithPercentFeeService = false,
}: GetRedirectUrlArgs) => {
  const baseUrl =
    partner === Partners.INTERVALE
      ? `sendme://sendmoney.intervale.ru/mtsResultSBP/${id}`
      : `${baseApi}/cyber/resultSBP/${id}`

  const params = {
    ...(isWebView ? { isWebView: true } : {}),
    ...(isFromPubgGiveawayPage ? { from: 'rozygrysh-prizov-pubg-mobile' } : {}),
    ...(url ? { url } : {}),
    ...(isNonTopUpService ? { voucher: true } : {}),
    ...(isTopUpWithPercentFeeService ? { topup: true } : {}),
  }

  return `${baseUrl}${composeQueryParams(params)}`
}
